





















import { InformationCircleIcon, LightBulbIcon, XCircleIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { DataError } from '@/app/components';
import ExpandCollapseIcon from './ExpandCollapseIcon.vue';

export default defineComponent({
    name: 'HistoricalGraph',
    components: {
        DataError,
        ExpandCollapseIcon,
        InformationCircleIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        errorResponse: {
            type: Object as PropType<{ message?: string; status: number }>,
            required: false,
        },
        showGraph: {
            type: Boolean,
            default: false,
        },
        expandable: {
            type: Boolean,
            default: true,
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        const error = computed(() => {
            if (!props.errorResponse) return null;
            if (props.errorResponse.status === 413)
                return {
                    message: 'Too many data points found with given time period',
                    tooltip: 'Change selected time period to reduce number of data points',
                    icon: LightBulbIcon,
                    classes: 'text-warn-700',
                };
            return {
                message: 'Unable to load historical metrics at this time...',
                tooltip: props.errorResponse.message,
                icon: XCircleIcon,
                classes: `text-danger-700`,
            };
        });

        return { error };
    },
});
